<template>
  <b-container>
    <b-row class="mt-4">
      <b-col lg="4">
        <b-card>
          <div slot="header">
            <strong>Year</strong>
            <em class="error invalid-feedback">{{ validateErrors.first('Year') }}</em>
          </div>
          <div style="height: 60vh; overflow: auto">
            <b-form-checkbox-group stacked :plain="false" v-model="activeVehicleSet.years"
                                   :checked="activeVehicleSet.years"
                                   v-validate="{required: true}"
                                   name="Year"
                                   v-bind:class="{'is-invalid': validateErrors.has('Year') }">
              <b-form-checkbox :id="y" v-for="y in form_options.years" @change="selectYear($event, y)" :value="y" v-bind:key="y">
                {{ y }}
              </b-form-checkbox>
            </b-form-checkbox-group>
          </div>
        </b-card>
      </b-col>
      <b-col lg="4" v-if="activeVehicleSet.years.length">
        <b-card>
          <div slot="header">
            <strong>Make</strong>
            <em class="error invalid-feedback">{{ validateErrors.first('Make') }}</em>
          </div>
          <a id="btnSelectAllMakes" href="javascript:void(0)" @click="selectallMakes(true)">Select All</a> | <a id="btnUnselectAllMakes" href="javascript:void(0)" @click="selectallMakes(false)">Unselect All</a>
          <div style="height: 60vh; overflow: auto">
            <b-form-checkbox-group stacked :plain="true"
                                   v-model="activeVehicleSet.makes"
                                   :checked="activeVehicleSet.makes"
                                   v-validate="{required: true}"
                                   name="Make"
                                   v-bind:class="{'is-invalid': validateErrors.has('Make') }">
              <b-form-checkbox :id="m.Name" v-for="m in sortArrays(form_options.makes)" :value="m"
                               @change="selectMake($event, m)"
                               v-bind:key="m.MakeID">
                {{ m.Name.replace('_',' ') }}
              </b-form-checkbox>
            </b-form-checkbox-group>

          </div>
        </b-card>
      </b-col>
      <b-col lg="4" v-if="activeVehicleSet.makes.length">
        <b-card>
          <div slot="header">
            <strong>Model</strong>
            <em class="error invalid-feedback">{{ validateErrors.first('Model') }}</em>
          </div>
          <div style="height: 62vh; overflow: auto">
            <div v-for="make in activeVehicleSet.makes">
              <strong>{{make.Name}}</strong><br />
              <small><a id="btnSelectAllModel" href="javascript:void(0)" @click="selectallModels(true,make.MakeID)">Select All</a> | <a id="btnUnselectAllModel" href="javascript:void(0)" @click="selectallModels(false,make.MakeID)">Unselect All</a></small>
              <b-form-checkbox-group stacked :plain="true"
                                     v-model="activeVehicleSet.models"
                                     :checked="activeVehicleSet.models"
                                     v-validate="{required: true}"
                                     name="Model"
                                     v-bind:class="{'is-invalid': validateErrors.has('Model') }">
                <b-form-checkbox :id="m.Name" v-for="m in sortArrays(form_options.models)" v-if="m.MakeID == make.MakeID" :value="m"
                                 v-bind:key="m.ModelID">
                  {{ m.Name.replace('_',' ') }}
                </b-form-checkbox>
              </b-form-checkbox-group>
            </div>
          </div>
        </b-card>
      </b-col>
      <b-col lg="3">
        <b-card>
          <div slot="header">
            <strong>Trim</strong>
          </div>
          <a href="javascript:void(0)" @click="selectallModels(true)">Select All</a> | <a href="javascript:void(0)" @click="selectallModels(false)">Unselect All</a>
          <div style="height: 200px; overflow: auto">
            <b-form-checkbox-group stacked :plain="true" v-model="activeVehicleSet.trims"
                                   :checked="activeVehicleSet.trims">
              <b-form-checkbox v-for="t in form_options.trims" :value="t" v-bind:key="t">
                {{ t }}
              </b-form-checkbox>
            </b-form-checkbox-group>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import loading from 'vue-full-loading'
  import notify from 'devextreme/ui/notify'
  import { Validator } from 'vee-validate'
  import { confirm } from 'devextreme/ui/dialog'
  import CompetitiveMappings from '@/views/mScopeCompetitiveMappings'

  export default {
    components: {
      loading,
      CompetitiveMappings
    },
    created() {
      axios.get('/api/mscope/getvehicles')
        .then(response => {
          this.boolLoading = false
          this.availableNewVehicles = response.data['NewVehicles']
          this.availableUsedVehicles = response.data['UsedVehicles']
          this.vehicles = this.availableNewVehicles
          this.form_options = this.availableNewOptions
          this.form_options.years = _.uniq(_.map(this.vehicles, 'Year'))
        })
        .catch(error => {
          if (error.response.status === 403) { this.$router.push('/login') }
          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })
      this.initLoad = true
    },
    data() {
      return {
        errMsg: '',
        initLoad: true,
        changesSaved: true,
        dismissibleType: 'danger',
        showDismissibleAlert: false,
        boolLoading: false,
        txtLoading: 'Loading...',
        activeVehicleSet: { id: -1, title: '', isnew: true, years: [], makes: [], models: [], trims: [] },
        blankVehicleSet: { id: -1, title: '', isnew: true, years: [], makes: [], models: [], trims: [] },
        availableNewOptions: { years: [], makes: [], models: [], trims: [] },
        availableUsedOptions: { years: [], makes: [], models: [], trims: [] },
        availableNewVehicles: [],
        availableUsedVehicles: [],
        vehicleSets: [],
        new_title: '',
        vehicles: [],
        form_options: {}
      }
    },
    methods: {
      handleOk(bvModalEvt) {
        bvModalEvt.preventDefault()
        if (this.new_title.length > 0) {
          this.handleSubmit()
        }
      },
      sortArrays(arrays) {
        return _.orderBy(arrays, 'Name', 'asc')
      },
      resetModal() {
        this.new_title = 'Copy - ' + this.activeVehicleSet.title
      },
      selectYear(event, year) {
        var SelectedModels = this.activeVehicleSet.models.filter(x => x)
        this.activeVehicleSet.models = []
        var SelectedMakes = this.activeVehicleSet.makes.filter(x => x)
        this.activeVehicleSet.makes = []
        setTimeout(() => {
          var vMakes = this.GetMakesByYears(this.vehicles, this.activeVehicleSet.years)

          this.form_options.makes = _.uniqBy(_.map(vMakes, 'Make'), 'MakeID').sort()

          var CoincidenceMakes = this.form_options.makes.filter(x => this.IsMakeInMakes(SelectedMakes, x.MakeID))
          if (CoincidenceMakes.length > 0) { this.activeVehicleSet.makes = CoincidenceMakes }
          var ModelsForThoseMakes = _.uniqBy(_.map(this.GetModelByMakesAndYears(this.vehicles, this.activeVehicleSet.years, CoincidenceMakes), 'Model'), 'ModelID')
          this.form_options.models = ModelsForThoseMakes
          var concidenceModels = this.form_options.models.filter(x => this.IsModelInModels(SelectedModels, x.ModelID))
          if (concidenceModels.length > 0) { this.activeVehicleSet.models = concidenceModels }
        }, 100)
      },
      selectMake(event, make) {
        var SelectedModels = this.activeVehicleSet.models.filter(x => x)
        setTimeout(() => {
          this.activeVehicleSet.models = []
          this.selectModelsByMakes(this.vehicles, this.activeVehicleSet.makes)
          var concidenceModels = this.form_options.models.filter(x => this.IsModelInModels(SelectedModels, x.ModelID))
          if (concidenceModels.length > 0) { this.activeVehicleSet.models = concidenceModels }
          this.selectallModels(true, make.MakeID)
        }, 100)
      },
      SwitchNewUsedElements() {
        if (this.activeVehicleSet.isnew) {
          this.vehicles = this.availableNewVehicles
          this.form_options = this.availableNewOptions
        } else {
          this.vehicles = this.availableUsedVehicles
          this.form_options = this.availableUsedOptions
        }
        this.form_options.years = _.uniq(_.map(this.vehicles, 'Year'))
      },
      unique(value, index, self) {
        return self.indexOf(value) === index
      },
      orderDesc(a, b) {
        return a < b
      },
      uniqueModel(value, index, self) {
        var idxFound = -1
        for (var idx = 0; idx < self.length; idx++) {
          if (self[idx].Model.Name == value.Model.Name) {
            return idx === index
          }
        }
        return false
      },
      orderByYearMakeModel(a, b) {
        var model_a = a.Year + '_' + a.Make.Name + '_' + a.Model.Name
        var model_b = b.Year + '_' + b.Make.Name + '_' + b.Model.Name
        if (model_a < model_b) { return -1 }
        if (model_a > model_b) { return 1 }
        return 0
      },
      orderByYearMakeModelDesc(a, b) {
        var model_a = a.Year + '_' + a.Make.Name + '_' + a.Model.Name
        var model_b = b.Year + '_' + b.Make.Name + '_' + b.Model.Name
        if (model_a > model_b) { return -1 }
        if (model_a < model_b) { return 1 }
        return 0
      },
      GetMakesByYears(Vehicles, Years) {
        const res = Vehicles.filter(x => Years.includes(x.Year))
          .filter(this.unique).sort()
        return res
      },
      GetModelByMakesAndYears(Vehicles, Years, Makes) {
        const res = Vehicles.filter(x => Years.includes(x.Year))
          .filter(x => this.IsMakeInMakes(Makes, x.Make.MakeID))
          .filter(this.uniqueModel).sort(this.orderByYearMakeModel)

        return res
      },
      selectallMakes(SelectAll) {
        let self = this
        var list = []
        self.activeVehicleSet.makes = list
        if (!SelectAll) { self.activeVehicleSet.models = [] }
        if (SelectAll) {
          self.form_options.makes.forEach(function (i) {
            list.push(i)
          })

          var SelectedModels = this.activeVehicleSet.models.filter(x => x)
          setTimeout(() => {
            this.activeVehicleSet.models = []
            this.selectModelsByMakesSelected(this.vehicles, list)
          }, 100)
        }
      },
      selectallModels(SelectAll, makeID) {
        let self = this
        var list = []
        self.activeVehicleSet.models.filter(m => m.MakeID !== makeID).forEach(function (i) {
          list.push(i)
        })
        this.activeVehicleSet.models = list
        if (SelectAll) {
          if (self.activeVehicleSet.isnew) {
            self.form_options.models.filter(m => m.MakeID === makeID).forEach(function (i) {
              list.push(i)
            })
          } else {
            self.form_options.models.filter(m => m.MakeID === makeID).forEach(function (i) {
              list.push(i)
            })
          }
        }
      },
      selectModelsByMakes(Vehicles, Makes) {
        var Models = this.GetModelByMakesAndYears(Vehicles, this.activeVehicleSet.years, Makes)
        this.form_options.models = _.uniqBy(_.map(Models, 'Model'), 'ModelID')
        this.form_options.models = this.form_options.models.sort()
      },
      selectModelsByMakesSelected(Vehicles, Makes) {
        var Models = this.GetModelByMakesAndYears(Vehicles, this.activeVehicleSet.years, Makes)
        this.form_options.models = _.uniqBy(_.map(Models, 'Model'), 'ModelID')
        this.form_options.models = this.form_options.models.sort()
        this.activeVehicleSet.models = this.form_options.models
      },
      IsMakeInMakes(Makes, MakeID) {
        return Makes.filter(x => x.MakeID == MakeID).length > 0
      },
      IsModelInModels(Models, ModelID) {
        return Models.filter(x => x.ModelID == ModelID).length > 0
      }
  
    },
    computed: {
      filteredModels: function () {
        return _.map(this.activeVehicleSet.models, 'ModelID')
      }
    },
    mounted() {
      // boolLoading must be set to false on data() binding so that mount hooks the change
      this.boolLoading = false
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/MultiVehicleSelect.vue